/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Docx_Txt_RecommendedInputs */

const en_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT recommended`)
};

const es_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado: PDF, DOCX, TXT`)
};

const fr_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT recommandés`)
};

const de_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT empfohlen`)
};

const ja_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF、DOCX、TXTを推奨`)
};

const zh_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐使用 PDF, DOCX, TXT`)
};

const ar_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يُنصح باستخدام PDF، DOCX، TXT`)
};

const id_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT disarankan`)
};

const it_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT consigliati`)
};

const ru_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуется: PDF, DOCX, TXT`)
};

const pt_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT recomendados`)
};

const ko_pdf_docx_txt_recommended = /** @type {(inputs: Pdf_Docx_Txt_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, DOCX, TXT 권장`)
};

/**
* | output |
* | --- |
* | "PDF, DOCX, TXT recommended" |
*
* @param {Pdf_Docx_Txt_RecommendedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pdf_docx_txt_recommended = /** @type {((inputs?: Pdf_Docx_Txt_RecommendedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Docx_Txt_RecommendedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pdf_docx_txt_recommended(inputs)
	if (locale === "es") return es_pdf_docx_txt_recommended(inputs)
	if (locale === "fr") return fr_pdf_docx_txt_recommended(inputs)
	if (locale === "de") return de_pdf_docx_txt_recommended(inputs)
	if (locale === "ja") return ja_pdf_docx_txt_recommended(inputs)
	if (locale === "zh") return zh_pdf_docx_txt_recommended(inputs)
	if (locale === "ar") return ar_pdf_docx_txt_recommended(inputs)
	if (locale === "id") return id_pdf_docx_txt_recommended(inputs)
	if (locale === "it") return it_pdf_docx_txt_recommended(inputs)
	if (locale === "ru") return ru_pdf_docx_txt_recommended(inputs)
	if (locale === "pt") return pt_pdf_docx_txt_recommended(inputs)
	return ko_pdf_docx_txt_recommended(inputs)
});